<script setup>
import TerminalForm from "@/components/terminal/TerminalForm.vue";

const route = useRoute();
const router = useRouter();

const loading = ref();

const load = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 3000);
};

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Data Terminal";

const pageMethod = "Create";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/terminal",
  },
  {
    title: pageMethod,
    to: null,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <TerminalForm v-model:pageMethod="pageMethod" v-model:pageTitle="pageTitle" />
</template>
